import { Routes } from '@angular/router';
import { LoginComponent } from '@pages/auth/login/login.component';
import {VerifyOtpLoginComponent} from '@pages/auth/verify-otp-login/verify-otp-login.component';
import {RecoveryPasswordComponent} from '@pages/auth/recovery-password/recovery-password.component';
import {
  RecoveryPasswordComfirmComponent
} from '@pages/auth/recovery-password/recovery-password-comfirm/recovery-password-comfirm.component';
import {
  RecoveryPasswordResetComponent
} from '@pages/auth/recovery-password/recovery-password-reset/recovery-password-reset.component';
import {
  RecoveryPasswordDoneComponent
} from '@pages/auth/recovery-password/recovery-password-done/recovery-password-done.component';

export const AUTH_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'verify-otp',
    component: VerifyOtpLoginComponent,
    data: {
      title: 'Verify OTP'
    }
  },
  {
    path: 'recovery-password',
    component: RecoveryPasswordComponent,
    data: {
      title: 'Recovery Password'
    }
  },
  {
    path: 'recovery-password-confirm',
    component: RecoveryPasswordComfirmComponent,
    data: {
      title: 'Recovery Password Confirm'
    }
  },
  {
    path: 'recovery-password-reset/accounts/reset/:uidb64/:token',
    component: RecoveryPasswordResetComponent,
    data: {
      title: 'Recovery Password Reset'
    }
  },
  {
    path: 'recovery-password-done',
    component: RecoveryPasswordDoneComponent,
    data: {
      title: 'Recovery Password Done'
    }
  }
];
